module.exports = __webpack_public_path__ + "static/media/apple-homekit-icon.ddfb5765.svg";